import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 536FA8E5-13DF-49A6-9C43-9874847AA01A
 * name moon-full
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-full.svg
 * tags
 * - Weather 
 */
export const MoonFullIcon = createSvgIcon(<><path d="M12 2A10 10 0 1 1 2 12A10 10 0 0 1 12 2Z" /></>, 'MoonFullIcon');
export default MoonFullIcon